'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ravenJs = require('raven-js');

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Boundary = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Boundary, _Component);

  function Boundary() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Boundary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Boundary.__proto__ || (0, _getPrototypeOf2.default)(Boundary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      error: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Boundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, errorInfo) {
      this.setState({ error: error });
      _ravenJs2.default.captureException(error, { extra: errorInfo });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.error) {
        return _react2.default.createElement(
          'div',
          {
            className: 'snap',
            onClick: function onClick() {
              return _ravenJs2.default.lastEventId() && _ravenJs2.default.showReportDialog();
            }
          },
          _react2.default.createElement(
            'p',
            null,
            'We\'re sorry \u2014 something\'s gone wrong.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Our team has been notified, but click here fill out a report.'
          )
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);
  return Boundary;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.array.isRequired
}, _temp2);
exports.default = Boundary;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Boundary.js
// module id = 1506
// module chunks = 0